'use client';

import { cn } from '@/utils/tailwind-merge';
import { InputHTMLAttributes, forwardRef } from 'react';
import { FieldError, UseFormRegister } from 'react-hook-form';
import Image from '../Image';

interface CustomInputProps extends InputHTMLAttributes<HTMLInputElement> {
    required?: boolean;
    className?: string;
    register?: UseFormRegister<any>;
    error?: FieldError | string;
    color?: 'white' | 'black';
    search?: boolean;
}

const Input = forwardRef<HTMLInputElement, CustomInputProps>((props, ref) => {
    const {
        className,
        required,
        type,
        register,
        error,
        color = 'black',
        search = false,
        disabled,
        ...inputProps
    } = props;

    return (
        <div className="flex flex-col relative">
            <input
                {...register}
                {...inputProps}
                ref={ref}
                type={type}
                className={cn(
                    'h-[72px] w-full border py-5 px-6 lg:text-h5 max-lg:text-h6 font-bold text-white placeholder-gray3/50 focus:border-border-gray3 focus:outline-none border-gray3 placeholder-shown:border-gray3 bg-transparent rounded-none uppercase leading-none',
                    error && 'border-red',
                    color === 'white' &&
                        'font-normal text-white placeholder-white/50 focus:border-border-white focus:outline-none border-white placeholder-shown:border-white',
                    search && 'border-t-0 border-l-0 border-r-0 p-2 h-auto',
                    disabled && 'opacity-80 cursor-default select-none',
                    className,
                )}
                placeholder={required ? `${inputProps.placeholder}*` : inputProps.placeholder}
                required={required}
            />

            {search && (
                <Image
                    className="ml-4 absolute top-1/2 -translate-y-1/2 right-0 lg:w-9 lg:h-9 w-6 h-6"
                    src="/img/icons/search.svg"
                    alt="Search Icon"
                    width={36}
                    height={36}
                />
            )}
            {error && <span className="text-red text-sm">{error as string}</span>}
        </div>
    );
});

Input.displayName = 'Input';

export default Input;
